/* global window, fetch */
(function () {
  if (window.JIYUCHO_SEATS_VIEW) return;

  function pad2(n) {
    return String(n).padStart(2, "0");
  }

  function ymdKeyFromDate(d) {
    var J = window.JIYUCHO_SCHEDULE.getJstComponents(d);
    return String(J.y) + "-" + pad2(J.m) + "-" + pad2(J.d);
  }

  function jstDateFromParts(y, m, d) {
    return new Date(String(y) + "-" + pad2(m) + "-" + pad2(d) + "T00:00:00+09:00");
  }

  function addDayNote(dayNotes, key, memo) {
    var text = String(memo || "").trim();
    if (!text) return;
    if (!dayNotes[key]) dayNotes[key] = [];
    if (dayNotes[key].indexOf(text) < 0) dayNotes[key].push(text);
  }

  function addPeriodMemoToDayNotes(dayNotes, dayBlocks, from, to, memo) {
    var curJ = window.JIYUCHO_SCHEDULE.getJstComponents(from);
    var endKey = ymdKeyFromDate(to);
    var cur = jstDateFromParts(curJ.y, curJ.m, curJ.d);

    while (ymdKeyFromDate(cur) <= endKey) {
      var key = ymdKeyFromDate(cur);
      addDayNote(dayNotes, key, memo);
      addDayNote(dayBlocks, key, memo);
      cur = new Date(cur.getTime() + 24 * 60 * 60 * 1000);
    }
  }

  function isEmptyPeopleValue(v) {
    return v == null || String(v).trim() === "";
  }

  function isPeriodMemoSegment(from, to, avail, people, memo) {
    if (!from || !to) return false;
    if (ymdKeyFromDate(from) === ymdKeyFromDate(to)) return false;
    if (avail !== 0) return false;
    if (!String(memo || "").trim()) return false;
    if (isEmptyPeopleValue(people)) return true;
    return parseInt(people, 10) === 0;
  }

  function toDateFromSegmentString(s) {
    if (!s) return null;

    var str = String(s).trim();
    var parts = str.split(" ");
    if (parts.length < 2) {
      var d0 = new Date(str);
      return isNaN(d0.getTime()) ? null : d0;
    }

    var datePart = parts[0].replace(/\//g, "-");
    var timePart = parts[1];

    var dp = datePart.split("-");
    var tp = timePart.split(":");

    var y = parseInt(dp[0], 10);
    var m = parseInt(dp[1], 10);
    var d = parseInt(dp[2], 10);

    var hh = parseInt(tp[0], 10);
    var mm = parseInt(tp[1], 10);
    var ss = tp.length >= 3 ? parseInt(tp[2], 10) : 0;

    if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return null;
    if (!Number.isFinite(hh) || !Number.isFinite(mm) || !Number.isFinite(ss)) return null;

    var iso =
      String(y) + "-" +
      pad2(m) + "-" +
      pad2(d) + "T" +
      pad2(hh) + ":" +
      pad2(mm) + ":" +
      pad2(ss) + "+09:00";

    var dt = new Date(iso);
    return isNaN(dt.getTime()) ? null : dt;
  }

  function buildByDayFromSegments(segments, storeKey, opt) {
    opt = opt || {};
    var minAvail = typeof opt.minAvail === "number" ? opt.minAvail : 1;

    var byDay = {};
    var dayNotes = {};
    var dayBlocks = {};
    for (var i = 0; i < segments.length; i++) {
      var seg = segments[i];
      if (!Array.isArray(seg) || seg.length < 3) continue;

      var from = toDateFromSegmentString(seg[0]);
      var to = toDateFromSegmentString(seg[1]);
      var avail = parseInt(seg[2], 10);
      var peopleRaw = seg[3];
      var memoRaw = seg[4] || '';

      if (!from || isNaN(from.getTime())) continue;
      if (!to || isNaN(to.getTime())) continue;
      if (!Number.isFinite(avail)) continue;

      if (isPeriodMemoSegment(from, to, avail, peopleRaw, memoRaw)) {
        addPeriodMemoToDayNotes(dayNotes, dayBlocks, from, to, memoRaw);
        continue;
      }

      if (avail < minAvail) continue;

      var ok = window.JIYUCHO_SCHEDULE.checkReservationDate(from, storeKey);
      if (!ok || !ok.ok) continue;

      var okDT = window.JIYUCHO_SCHEDULE.isBusinessDateTime(from, storeKey);
      if (!okDT || !okDT.ok) continue;

      var ymd = ymdKeyFromDate(from);
      if (!byDay[ymd]) byDay[ymd] = [];

      byDay[ymd].push({
        from: from,
        to: to,
        avail: avail,
        people: (peopleRaw != null ? parseInt(peopleRaw, 10) : null),
        memo: memoRaw,
        url: seg[5] || ''
      });
    }

    Object.keys(byDay).forEach(function (k) {
      byDay[k].sort(function (a, b) {
        return a.from.getTime() - b.from.getTime();
      });
    });

    return { byDay: byDay, dayNotes: dayNotes, dayBlocks: dayBlocks };
  }

  async function fetchJson(url) {
    var controller = new AbortController();
    var timer;
    try {
      return await Promise.race([fetch(url, { method: "GET", credentials: "omit", signal: controller.signal }).then(function (res) {
        if (!res.ok) throw new Error("Availability unavailable");
        return res.json();
      }), new Promise(function (_, reject) {
        timer = setTimeout(function () { controller.abort(); reject(new Error("Availability timeout")); }, 45000);
      })]);
    } finally { clearTimeout(timer); }
  }

  // /mnt/data/jiyucho_seats_view (2).js
  async function buildBusinessSeatView(viewUrl, storeKey, opt) {
    var payload = await fetchJson(viewUrl);
    // HTTP 200のエラーや欠損・不正区間を、正常な空日の省略と混同しない。
    if (!payload || payload.ok !== true || !Array.isArray(payload.segments) ||
        payload.segments.some(function (row) {
          if (!Array.isArray(row)) return true;
          var from = toDateFromSegmentString(row[0]);
          var to = toDateFromSegmentString(row[1]);
          return !from || !to || to.getTime() < from.getTime() ||
            isEmptyPeopleValue(row[2]) || !Number.isFinite(Number(row[2]));
        })) throw new Error("Availability source unavailable");

    // まずは汎用パーサ
    var built = window.JIYUCHO_SCHEDULE.buildBusinessSlotsFromViewPayload(payload, storeKey, opt);
    var byDay = (built && built.byDay) ? built.byDay : {};
    var dayNotes = (built && built.dayNotes) ? built.dayNotes : {};
    var dayBlocks = (built && built.dayBlocks) ? built.dayBlocks : {};

    // ここを追加: slots などで取れず空の時は segments を読む
    try {
      var empty = !byDay || Object.keys(byDay).length === 0;
      if (empty && payload && Array.isArray(payload.segments) && payload.segments.length > 0) {
        var segBuilt = buildByDayFromSegments(payload.segments, storeKey, opt);
        if (segBuilt && segBuilt.byDay) byDay = segBuilt.byDay;
        if (segBuilt && segBuilt.dayNotes) dayNotes = segBuilt.dayNotes;
        if (segBuilt && segBuilt.dayBlocks) dayBlocks = segBuilt.dayBlocks;
      }
    } catch (e) {}

    return {
      payload: payload,
      byDay: byDay,
      dayNotes: dayNotes,
      dayBlocks: dayBlocks
    };
  }


  window.JIYUCHO_SEATS_VIEW = { buildBusinessSeatView: buildBusinessSeatView };
})();
